import { render, staticRenderFns } from "./whiteInof.vue?vue&type=template&id=77debae3&"
import script from "./whiteInof.vue?vue&type=script&lang=js&"
export * from "./whiteInof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports